import React from "react";
import CollapsibleTable from "../CollapsibleTable";
import { createPaymentData } from "../CollapsibleTable/dataFunctions";
import { toTwoDecimalPlaces } from "../../../utils/commonFunctions";

const PaymentTable = ({ data, loading, paginationData, setPageSize, count, pageSize, setCount }) => {
  const heading = ["Order no.", "Date", "Total Items", "Earnings"];

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const paymentRows = data?.map((item) =>
    createPaymentData(
      `#${item?.order_id}`,
      formatDate(item?.order_date),
      item?.total_items,
      `$${toTwoDecimalPlaces(item?.earned)}`
    )
  );

  return (
    <CollapsibleTable
      loading={loading}
      showPagination={true}
      headings={heading}
      rows={paymentRows}
      isDownIconVisible={false}
      totalCount={paginationData?.total_count}
      totalPages={paginationData?.total_pages}
      pageNo={count}
          pageSize={
            paginationData?.total_count >= 10
              ? pageSize
              : paginationData?.total_count
          }
      setPageNo={setCount}
      setPageSize={setPageSize}
    />
  );
};

export default PaymentTable;
